export const CACHE_CONFIG = {};
